import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reset",
  "use": "icon-reset-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" id=\"icon-reset\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.463 10.069a4.537 4.537 0 0 1 7.991-4.295l-1.186.33a.267.267 0 0 0-.088.47l2.464 1.846a.2.2 0 0 0 .306-.085l1.155-2.854a.267.267 0 0 0-.319-.357l-1.017.284-.044-.085a5.87 5.87 0 1 0-2.547 7.901.667.667 0 1 0-.608-1.186 4.537 4.537 0 0 1-6.107-1.97Z\" fill=\"#B2B6C0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol